import React, { useState } from 'react';
import {
  VStack, FormControl, FormLabel, Input, Select, Textarea,
  Button, HStack, SimpleGrid, useToast,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';

interface Props {
  taller?: any;
  onGuardado: () => void;
}

const TIPOS = ['Arte', 'Música', 'Danza', 'Teatro', 'Literatura', 'Artesanías', 'Otro'];

const FormularioTaller: React.FC<Props> = ({ taller, onGuardado }) => {
  const toast = useToast();
  const [guardando, setGuardando] = useState(false);

  const [form, setForm] = useState({
    titulo: taller?.titulo || '',
    tipo: taller?.tipo || 'Arte',
    tallerista: taller?.tallerista || '',
    lugar: taller?.lugar || '',
    cupo: taller?.cupo || '',
    fechaTaller: taller?.fechaTaller ? taller.fechaTaller.substring(0, 10) : '',
    horaInicio: taller?.horaInicio || '',
    horaFin: taller?.horaFin || '',
    descripcion: taller?.descripcion || '',
  });

  const set = (field: string, value: string) => setForm((p) => ({ ...p, [field]: value }));

  const handleGuardar = async () => {
    if (!form.titulo || !form.tipo || !form.tallerista || !form.lugar || !form.cupo || !form.fechaTaller) {
      toast({ title: 'Completa los campos obligatorios', status: 'warning', duration: 3000 });
      return;
    }
    setGuardando(true);
    try {
      const formData = new FormData();
      Object.entries(form).forEach(([k, v]) => formData.append(k, String(v)));
      if (taller?.id) {
        await axiosInstance.put(`/cultura/talleres/${taller.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        toast({ title: 'Taller actualizado', status: 'success', duration: 3000 });
      } else {
        await axiosInstance.post('/cultura/talleres', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        toast({ title: 'Taller creado', status: 'success', duration: 3000 });
      }
      onGuardado();
    } catch (e: any) {
      toast({ title: 'Error', description: e?.response?.data?.message || 'Error al guardar', status: 'error', duration: 4000 });
    } finally {
      setGuardando(false);
    }
  };

  return (
    <VStack spacing={4} align="stretch">
      <FormControl isRequired>
        <FormLabel fontSize="sm">Título del taller</FormLabel>
        <Input value={form.titulo} onChange={(e) => set('titulo', e.target.value)} placeholder="Ej. Taller de pintura en acuarela" />
      </FormControl>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <FormControl isRequired>
          <FormLabel fontSize="sm">Tipo</FormLabel>
          <Select value={form.tipo} onChange={(e) => set('tipo', e.target.value)}>
            {TIPOS.map((t) => <option key={t} value={t}>{t}</option>)}
          </Select>
        </FormControl>
        <FormControl isRequired>
          <FormLabel fontSize="sm">Tallerista / Instructor</FormLabel>
          <Input value={form.tallerista} onChange={(e) => set('tallerista', e.target.value)} placeholder="Nombre del instructor" />
        </FormControl>
        <FormControl isRequired>
          <FormLabel fontSize="sm">Lugar</FormLabel>
          <Input value={form.lugar} onChange={(e) => set('lugar', e.target.value)} placeholder="Lugar donde se impartirá" />
        </FormControl>
        <FormControl isRequired>
          <FormLabel fontSize="sm">Cupo máximo</FormLabel>
          <Input type="number" min={1} value={form.cupo} onChange={(e) => set('cupo', e.target.value)} placeholder="Número de participantes" />
        </FormControl>
        <FormControl isRequired>
          <FormLabel fontSize="sm">Fecha del taller</FormLabel>
          <Input type="date" value={form.fechaTaller} onChange={(e) => set('fechaTaller', e.target.value)} />
        </FormControl>
        <HStack spacing={2} align="flex-end">
          <FormControl>
            <FormLabel fontSize="sm">Hora inicio</FormLabel>
            <Input type="time" value={form.horaInicio} onChange={(e) => set('horaInicio', e.target.value)} />
          </FormControl>
          <FormControl>
            <FormLabel fontSize="sm">Hora fin</FormLabel>
            <Input type="time" value={form.horaFin} onChange={(e) => set('horaFin', e.target.value)} />
          </FormControl>
        </HStack>
      </SimpleGrid>
      <FormControl>
        <FormLabel fontSize="sm">Descripción</FormLabel>
        <Textarea rows={3} value={form.descripcion} onChange={(e) => set('descripcion', e.target.value)}
          placeholder="Descripción del taller, objetivos, materiales necesarios..." />
      </FormControl>
      <Button bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={handleGuardar}
        isLoading={guardando} loadingText="Guardando...">
        {taller?.id ? 'Actualizar taller' : 'Crear taller'}
      </Button>
    </VStack>
  );
};

export default FormularioTaller;
